import Carousel from "react-material-ui-carousel";
import { Paper } from "@material-ui/core";

import { NavigateNext, NavigateBefore } from "@material-ui/icons";
import ImagePlaceholder from "components/Image/ImagePlaceholder";

export default function CarouselShowCase({ isMobile, items }) {
  function Item(props) {
    return (
      <Paper
        style={{
          minWidth: isMobile ? 220 : 260,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <ImagePlaceholder
          alt="Imagem do item do pedido"
          src={props.item.Url}
          width={isMobile ? 170 : 200}
          widthOnError={isMobile ? 170 : 200}
          imagePreviewTitle={`Produto`}
        />
      </Paper>
    );
  }

  return (
    <Carousel
      navButtonsAlwaysVisible
      autoPlay={false}
      indicators
      swipe
      cycleNavigation
      NextIcon={<NavigateNext />}
      PrevIcon={<NavigateBefore />}
      navButtonsProps={{
        style: {
          width: "1rem",
        },
      }}
      navButtonsWrapperProps={{
        style: {
          bottom: "0",
          top: "unset",
        },
      }}
    >
      {items?.map((item, i) => (
        <Item key={i} item={item} />
      ))}
    </Carousel>
  );
}
